import { render } from "./ErrorLabel.vue?vue&type=template&id=0aa2a90f"
import script from "./ErrorLabel.vue?vue&type=script&lang=js"
export * from "./ErrorLabel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__